import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'

export interface ServiceListReq {
  price_ids?: number[]
}

export interface ServiceList {
  /** 周期数量，比如date_kind=4，cycle_count=2，表示2年 */
  date_kind: number
  /** 周期数量，比如date_kind=4，cycle_count=2，表示2年 */
  cycle_count: number
  /** 原订阅数量 */
  terminal_count: number
  /** 服务到期时间 */
  expire_time: string
  /** 金额（分） */
  amount?: number
  /** 权益服务名称 */
  display_name?: string
  /** 权益服务key */
  permission_name?: string
  price_id?: number
  subscription_time?: number
}

export interface ServiceListRes {
  service_list?: ServiceList[]
}

@Injectable()
export class RenewalServiceService {
  constructor (private http: Http) {}

  @InvokeThrottle()
  getServiceList (data: ServiceListReq) {
    return this.http.post<ServiceListRes>('/permission_service/expire_service_list', data)
  }
}
